import { createBrowserHistory, Path, History } from 'history';

const ROLLBACK_PARAM_NAME = 'back_url';

interface IHistory extends History {
  replaceWithRollback(path: Path): void;
  rollback(): boolean;
  goBackSmart(backPath?: string): void;
}

interface IParams {
  defaultBackPath: string;
}

const createHistory = (params: IParams): IHistory => {
  const prototype: History = createBrowserHistory();
  const initialLength = history.length;

  return Object.assign(prototype, {
    goBackSmart(this: IHistory, defaultBackPath = params.defaultBackPath) {
      if (history.length === initialLength) {
        this.replace(defaultBackPath);

        return;
      }

      this.goBack();
    },

    replaceWithRollback(this: IHistory, path: Path): void {
      if (path === this.location.pathname) {
        return;
      }

      const [pathname, search = ''] = path.split('?');
      const searchParams = new URLSearchParams(search);

      searchParams.append(ROLLBACK_PARAM_NAME, this.location.pathname);

      this.replace([pathname, searchParams.toString()].join('?'));
    },
    rollback(this: IHistory): boolean {
      const rollbackPath = new URLSearchParams(this.location.search).get(ROLLBACK_PARAM_NAME);

      if (!rollbackPath) {
        return false;
      }

      this.replace(rollbackPath);

      return true;
    },
  });
};

export type { IHistory };
export { createHistory };
